import Editor from '@/components/Editor/Editor'
import { Artifact } from '@/components/Header/Header'
import { cn } from '@flatfile/baseline'

interface ArtifactViewProps {
  artifact: Artifact
  className?: string
}

export function ArtifactView({ artifact, className }: ArtifactViewProps) {
  const renderAnalysisContent = () => {
    if (!artifact.data?.analysisResults) {
      return <div className='text-gray-500'>No analysis data available</div>
    }

    const analysisResults = artifact.data.analysisResults

    // Convert the analysis results to markdown format
    const markdownContent = `
# ${artifact.name || 'File Analysis Report'}

${analysisResults.summary || analysisResults}

## Field Analysis

${
  analysisResults.fieldAnalyses
    ?.map(
      (field: any) => `
### ${field.key}
**Type:** ${field.type}  
**Confidence:** ${field.confidenceScore}%

#### Issues Found:
${field.issues?.map((issue: string) => `- ${issue}`).join('\n') || 'No issues found'}

#### Suggestions:
${field.suggestions?.map((suggestion: string) => `- ${suggestion}`).join('\n') || 'No suggestions'}

#### Examples:
${field.examples?.length > 0 ? field.examples.map((example: string) => `\`${example}\``).join(', ') : 'No examples'}
`
    )
    .join('\n') || ''
}

## General Suggestions

${analysisResults.generalSuggestions?.map((suggestion: string) => `- ${suggestion}`).join('\n') || 'No general suggestions'}

---
*Analysis performed on ${new Date(artifact.data.analysisMetadata?.analyzedAt || Date.now()).toLocaleString()}*  
*Sample size: ${artifact.data.analysisMetadata?.sampleSize || 'Unknown'} records*
`

    return markdownContent
  }

  const renderReportContent = () => {
    if (!artifact.data?.reportContent) {
      return <div className='text-gray-500'>No report content available</div>
    }

    return artifact.data.reportContent
  }

  const getContentToRender = () => {
    if (artifact.type === 'report') {
      return typeof artifact.data?.reportContent === 'string'
        ? artifact.data.reportContent
        : renderReportContent()
    } else if (artifact.type === 'file_analysis') {
      return typeof artifact.data?.analysisResults === 'string'
        ? artifact.data.analysisResults
        : renderAnalysisContent()
    } else {
      return 'Unsupported artifact type'
    }
  }

  if (artifact.type === 'report') {
    return (
      <div className={cn('h-full overflow-auto bg-gray-50', className)}>
        <div className='max-w-4xl mx-auto py-8 px-6'>
          <Editor content={getContentToRender()} />
        </div>
      </div>
    )
  }

  if (artifact.type === 'file_analysis') {
    return (
      <div className={cn('h-full overflow-auto bg-gray-50', className)}>
        <div className='max-w-4xl mx-auto py-8 px-6'>
          <Editor content={getContentToRender()} />
        </div>
      </div>
    )
  }

  return null
}
